import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import RotateFlipImage from '../../components/RotateFlipImage';

const RotateFlipPage: React.FC = () => (
  <ToolLayout
    title="Rotate & Flip Image Online Free | AllTools"
    description="Rotate images 90, 180, 270 degrees or flip horizontally and vertically. Free online tool."
    canonicalPath="/rotate-flip-image"
  >
    <RotateFlipImage />
  </ToolLayout>
);

export default RotateFlipPage;
